module.exports = __webpack_public_path__ + "img/iconCC-Social1.911288b2.png";